<template>
    <div>
        <b-card no-body header="heder">
            <template v-slot:header>
                <div class="d-flex justify-content-between"><!-- title row start-->
                    <h3 class="" @click='windowResized'>Statistics</h3>
                    <!--230214 / 아래 주석 -->
                    <!-- <div class="d-flex justify-content-end"> -->
                    <!-- <b-form inline> -->
                    <!-- <label for="level-list"  class="mr-2 ml-2">그룹</label> -->
                    <!-- <b-form-select id="level-list" @change="reloadStatistics($event)" v-model="selectedGroup" :options="groupOptions" size="sm" class=""></b-form-select> -->
                    <!-- //<button type="button" class="ml-5 btn btn-blue btn-sm" @click="reloadStatistics()">Reload</button> -->
                    <!-- </b-form> -->
                    <!-- </div>  -->

                </div> <!-- title row end-->

            </template>
            <b-tabs card id="chartBorder">
                <loading :active.sync="statisticsLoading" :can-cancel="true" :is-full-page="false"></loading>

                <b-tab title="Daily Timeline" active>
                    <div class="card">
                        <h5 class="card-header bg-dark">
                            <div class="d-flex justify-content-between">
                                <div>
                                    <div style="cursor: pointer;" class="text-warning"
                                         @click="openDatepicker('datepicker1')">{{ selectedDate | moment('YYYY-MM-DD') }}
                                    </div>
                                    <datepicker ref="datepicker1" v-model='selectedDate' :format='datepicker.format'
                                                :highlighted='datepicker.highlighted'></datepicker>
                                </div>
                                <button type="button" class="ml-2 btn btn-blue btn-sm"
                                        @click="retrieveScriptRunningHistoryList()">Reload</button>
                            </div>
                            <div class="text-white">Total Running Time: {{ totalDailyRunningSeconds | readableTime }}</div>
                        </h5>
                        <div class="d-flex border">
                            <div id="dailyTimeline" style="height: auto;"></div> <!-- Google Timeline Chart -->
                        </div>
                    </div> <!-- card end -->
                </b-tab>

                <b-tab title="Daily Table">
                    <h5 class="card-header bg-dark">
                        <div class="d-flex justify-content-between">
                            <div>
                                <div style="cursor: pointer;" class="text-warning" @click="openDatepicker('datepicker2')">{{
                                    selectedDate | moment('YYYY-MM-DD') }}</div>
                                <datepicker ref="datepicker2" v-model='selectedDate' :format='datepicker.format'
                                            :highlighted='datepicker.highlighted'></datepicker>
                            </div>
                            <div>
                                <button type="button" class="ml-2 btn btn-blue btn-sm"
                                        @click="retrieveScriptRunningHistoryList()">Reload</button>
                                <button type="button" class="ml-2 btn btn-blue btn-sm" @click="dailyTableExport()">Export
                                    Excel</button>
                            </div>
                        </div>
                        <div class="text-white">Total Running Time: {{ totalDailyRunningSeconds | readableTime }}</div>
                    </h5>
                    <table class="table table-striped table-bordered table-hover shadow-sm">
                        <thead class="statistics-header">
                            <tr class="text-center">
                                <th>Name</th>
                                <th>프로세스(버전)</th>
                                <th>시작 시간</th>
                                <th>종료 시간</th>
                                <th>실행 시간(초)</th>
                                <th>결과값</th>
                                <th>자세히</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(daily, index) in dailyList"> <!-- v-bind:key="license.deviceId" -->
                                <td>{{ daily.alias }}</td>
                                <td>{{ showProcessName(daily.processName, daily.version, daily.file) }}</td>
                                <td>{{ daily.startedTime | moment('HH:mm:ss') }}</td>
                                <td>{{ daily.finishedTime | moment('HH:mm:ss') }}</td>
                                <td>{{ daily.runningSeconds | currency }}</td>
                                <!-- <td><div :class="expiringClass(license.to, license.status)">{{ license.to | moment('YYYY-MM-DD') }}</div></td> -->
                                <td>{{ daily.resultCode }}</td>
                                <td class="text-center">
                                    <button type="button" class="btn btn-blue"
                                            @click="triggerProcessEvent(daily.deviceId, daily.uuid)">Detail</button>
                                </td>
                            </tr>
                            <tr v-show="dailyList == null || dailyList.length == 0">
                                <td class="text-center" colspan="7">결과가 없습니다.</td>
                            </tr>
                        </tbody>
                    </table>
                </b-tab>

                <b-tab title="Period" @click="windowResized">
                    <div class="card">
                        <!-- <h5 class="card-header bg-dark text-white"><div class="text-warning">{{ thisMonth }}</div></h5> -->
                        <h5 class="card-header bg-dark">
                            <div class="d-flex justify-content-between">
                                <div class="d-flex flex-row">
                                    <div style="cursor: pointer;" class="text-warning"
                                         @click="openDatepicker('fromDatePicker')">{{ fromDate | moment('YYYY-MM-DD') }}
                                    </div>
                                    <datepicker ref="fromDatePicker" v-model='fromDate' :format='datepicker.format'
                                                :highlighted='datepicker.highlighted'></datepicker>
                                    <div class="text-warning ml-2 mr-2"> ~ </div>
                                    <div style="cursor: pointer;" class="text-warning"
                                         @click="openDatepicker('toDatePicker')">{{ toDate | moment('YYYY-MM-DD') }}</div>
                                    <datepicker ref="toDatePicker" v-model='toDate' :format='datepicker.format'
                                                :highlighted='datepicker.highlighted'></datepicker>
                                </div>
                                <div>
                                    <button class="ml-2 btn btn-blue btn-sm" @click="retrieveStatistics2()">Reload</button>
                                    <button type="button" class="ml-2 btn btn-blue btn-sm" @click="exportExcel()">Export
                                        Excel</button>
                                    <button type="button" class="ml-5 btn btn-success btn-sm"
                                            @click="retrieveStatistics2('today')">오늘</button>
                                    <button type="button" class="ml-1 btn btn-success btn-sm"
                                            @click="retrieveStatistics2('yesterday')">어제</button>
                                    <button type="button" class="ml-1 btn btn-success btn-sm"
                                            @click="retrieveStatistics2('thisWeek')">금주</button>
                                    <button type="button" class="ml-1 btn btn-success btn-sm"
                                            @click="retrieveStatistics2('lastWeek')">전주</button>
                                    <button type="button" class="ml-1 btn btn-success btn-sm"
                                            @click="retrieveStatistics2('thisMonth')">이달</button>
                                    <button type="button" class="ml-1 btn btn-success btn-sm"
                                            @click="retrieveStatistics2('lastMonth')">전달</button>
                                </div>
                            </div>
                            <div class="text-white">Total Running Time: {{ totalRunningSeconds | readableTime }}</div>
                        </h5>
                        <div class="d-flex flex-row">
                            <div class="border w-50">
                                <div id="monthlyPeon"></div>
                            </div>
                            <div class="border w-50">
                                <div id="monthlyPeon2"></div>
                            </div>
                        </div>

                        <div class="border w-100">
                            <div id="monthlyPeon4"></div>
                        </div>
                        <div class="border w-100">
                            <div id="monthlyPeon3">></div>
                        </div>
                        <div class="border w-100">
                            <div id="monthlyPeon6">></div>
                        </div>
                        <div class="border w-100">
                            <div id="monthlyPeon5">></div>
                        </div>
                        <div class="border w-100">
                            <div id="monthlyPeon7">></div>
                        </div>
                    </div> <!-- card end -->

                </b-tab> <!--Monthly end ---->

                <b-tab id="botlist" title="Statistics" v-if="false">
                    <div class="card-body">
                        <table class="table table-striped table-bordered table-hover shadow-sm">
                            <thead class="statistics-header">
                                <tr class="text-center">
                                    <th></th>
                                    <th>금일</th>
                                    <th>어제</th>
                                    <th>이번 주</th>
                                    <th>지난 주</th>
                                    <th>이번 달</th>
                                    <th>지난 달</th>
                                </tr>
                                <tr class="text-center statistics-header2">
                                    <!-- <th rowspan='2' class="align-middle">전체</th> -->
                                    <th class="align-middle">전체 (성공/실패)</th>
                                    <th>
                                        {{ getSummary("today", "totalTasks") }} ( {{ getSummary("today", "successTasks") }}
                                        / {{ getSummary("today", "failTasks") }} )
                                        <div
                                             v-bind:class="gridContainer(getSummary('today', 'successTasks'), getSummary('today', 'failTasks'))">
                                            <div class="item_success bar-animated"></div>
                                            <div class="item_fail bar-animated"></div>
                                        </div>
                                        <!--{{ parseInt((getSummary("today", "successTasks") / getSummary("today", "totalTasks")) * 100)  }} % -->
                                    </th>
                                    <th>
                                        {{ getSummary("yesterday", "totalTasks") }} ( {{ getSummary("yesterday",
                                            "successTasks") }} / {{ getSummary("yesterday", "failTasks") }} )

                                        <div
                                             v-bind:class="gridContainer(getSummary('yesterday', 'successTasks'), getSummary('yesterday', 'failTasks'))">
                                            <div class="item_success bar-animated"></div>
                                            <div class="item_fail bar-animated"></div>
                                        </div>
                                    </th>
                                    <th>
                                        {{ getSummary("thisWeek", "totalTasks") }} ( {{ getSummary("thisWeek",
                                            "successTasks") }} / {{ getSummary("thisWeek", "failTasks") }} )

                                        <div
                                             v-bind:class="gridContainer(getSummary('thisWeek', 'successTasks'), getSummary('thisWeek', 'failTasks'))">
                                            <div class="item_success bar-animated"></div>
                                            <div class="item_fail bar-animated"></div>
                                        </div>

                                    </th>
                                    <th>
                                        {{ getSummary("lastWeek", "totalTasks") }} ( {{ getSummary("lastWeek",
                                            "successTasks") }} / {{ getSummary("lastWeek", "failTasks") }} )

                                        <div
                                             v-bind:class="gridContainer(getSummary('lastWeek', 'successTasks'), getSummary('lastWeek', 'failTasks'))">
                                            <div class="item_success bar-animated"></div>
                                            <div class="item_fail bar-animated"></div>
                                        </div>
                                    </th>
                                    <th>
                                        {{ getSummary("thisMonth", "totalTasks") }} ( {{ getSummary("thisMonth",
                                            "successTasks") }} / {{ getSummary("thisMonth", "failTasks") }} )

                                        <div
                                             v-bind:class="gridContainer(getSummary('thisMonth', 'successTasks'), getSummary('thisMonth', 'failTasks'))">
                                            <div class="item_success bar-animated"></div>
                                            <div class="item_fail bar-animated"></div>
                                        </div>
                                    </th>
                                    <th>
                                        {{ getSummary("lastMonth", "totalTasks") }} ( {{ getSummary("lastMonth",
                                            "successTasks") }} / {{ getSummary("lastMonth", "failTasks") }} )

                                        <div
                                             v-bind:class="gridContainer(getSummary('lastMonth', 'successTasks'), getSummary('lastMonth', 'failTasks'))">
                                            <div class="item_success bar-animated"></div>
                                            <div class="item_fail bar-animated"></div>
                                        </div>
                                    </th>
                                </tr>
                                <tr class="text-center statistics-header2">

                                    <th class="align-middle">실행 시간 (sec)</th>
                                    <th>
                                        {{ getSummary("today", "runningSeconds") | currency }}
                                        <!--/{{ getSummary("today", "totalSeconds") }} -->
                                    </th>
                                    <th>
                                        {{ getSummary("yesterday", "runningSeconds") | currency }}
                                    </th>
                                    <th>
                                        {{ getSummary("thisWeek", "runningSeconds") | currency }}
                                    </th>
                                    <th>
                                        {{ getSummary("lastWeek", "runningSeconds") | currency }}
                                    </th>
                                    <th>
                                        {{ getSummary("thisMonth", "runningSeconds") | currency }}
                                    </th>
                                    <th>
                                        {{ getSummary("lastMonth", "runningSeconds") | currency }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(peon, index) in peonList">
                                    <tr class="text-center">
                                        <td rowspan='2'>{{ peon.alias }}</td>
                                        <td>
                                            {{ getStat(peon, "today", "totalTasks") }} ({{ getStat(peon, "today",
                                                "successTasks") }} / {{ getStat(peon, "today", "failTasks") }})
                                            <br />
                                            <div
                                                 v-bind:class="gridContainer(getStat(peon, 'today', 'successTasks'), getStat(peon, 'today', 'failTasks'))">
                                                <div class="item_slim_success bar-animated"></div>
                                                <div class="item_slim_fail bar-animated"></div>
                                            </div>
                                        </td>
                                        <td>{{ getStat(peon, "yesterday", "totalTasks") }} ({{ getStat(peon, "yesterday",
                                            "successTasks") }} / {{ getStat(peon, "yesterday", "failTasks") }})
                                            <br />
                                            <div
                                                 v-bind:class="gridContainer(getStat(peon, 'yesterday', 'successTasks'), getStat(peon, 'yesterday', 'failTasks'))">
                                                <div class="item_slim_success bar-animated"></div>
                                                <div class="item_slim_fail bar-animated"></div>
                                            </div>
                                        </td>
                                        <td>{{ getStat(peon, "thisWeek", "totalTasks") }} ({{ getStat(peon, "thisWeek",
                                            "successTasks") }} / {{ getStat(peon, "thisWeek", "failTasks") }})
                                            <br />
                                            <div
                                                 v-bind:class="gridContainer(getStat(peon, 'thisWeek', 'successTasks'), getStat(peon, 'thisWeek', 'failTasks'))">
                                                <div class="item_slim_success bar-animated"></div>
                                                <div class="item_slim_fail bar-animated"></div>
                                            </div>
                                        </td>
                                        <td>{{ getStat(peon, "lastWeek", "totalTasks") }} ({{ getStat(peon, "lastWeek",
                                            "successTasks") }} / {{ getStat(peon, "lastWeek", "failTasks") }})
                                            <br />
                                            <div
                                                 v-bind:class="gridContainer(getStat(peon, 'lastWeek', 'successTasks'), getStat(peon, 'lastWeek', 'failTasks'))">
                                                <div class="item_slim_success bar-animated"></div>
                                                <div class="item_slim_fail bar-animated"></div>
                                            </div>
                                        </td>
                                        <td>{{ getStat(peon, "thisMonth", "totalTasks") }} ({{ getStat(peon, "thisMonth",
                                            "successTasks") }} / {{ getStat(peon, "thisMonth", "failTasks") }})
                                            <br />
                                            <div
                                                 v-bind:class="gridContainer(getStat(peon, 'thisMonth', 'successTasks'), getStat(peon, 'thisMonth', 'failTasks'))">
                                                <div class="item_slim_success bar-animated"></div>
                                                <div class="item_slim_fail bar-animated"></div>
                                            </div>
                                        </td>
                                        <td>{{ getStat(peon, "lastMonth", "totalTasks") }} ({{ getStat(peon, "lastMonth",
                                            "successTasks") }} / {{ getStat(peon, "lastMonth", "failTasks") }})
                                            <br />
                                            <div
                                                 v-bind:class="gridContainer(getStat(peon, 'lastMonth', 'successTasks'), getStat(peon, 'lastMonth', 'failTasks'))">
                                                <div class="item_slim_success bar-animated"></div>
                                                <div class="item_slim_fail bar-animated"></div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr class="text-center">
                                        <td>{{ getStat(peon, "today", "runningSeconds") | currency }}</td>
                                        <td>{{ getStat(peon, "yesterday", "runningSeconds") | currency }}</td>
                                        <td>{{ getStat(peon, "thisWeek", "runningSeconds") | currency }}</td>
                                        <td>{{ getStat(peon, "lastWeek", "runningSeconds") | currency }}</td>
                                        <td>{{ getStat(peon, "thisMonth", "runningSeconds") | currency }}</td>
                                        <td>{{ getStat(peon, "lastMonth", "runningSeconds") | currency }}</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div> <!--card body end -->
                </b-tab>

            </b-tabs>
        </b-card>
        <!-- </div> --><!--//running robot end-->
        <b-modal id="messageModal" header-class="fail-header" title="Message" ok-only ok-variant="secondary"
                 ok-title="Close">
            <p class="my-4 text-center">{{ msgContent }}</p>
        </b-modal>
    </div>
</template>

<script>
import { mapState } from 'vuex'

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import Datepicker from 'vuejs-datepicker';
import * as XLSX from 'xlsx';

export default {
    name: 'Statistics',
    data() {
        return {
            statisticsLoading: false,
            dailyList: [],

            msgStatus: '',  // alert popup 의 status 인데 사용하진 않고, 아래 content는 보여줌
            msgContent: '',

            dailyData: [],
            dailyOptions: [],

            totalDailyRunningSeconds: 0,  // 어제 전체 실행한 시간
            totalRunningSeconds: 0,  // 이건 전체 실행 시간 (Period에서 설정한 기간에 실행한 시간)

            dailyChart: null,

            monthlyChart: null,
            monthlyChart2: null,  // TODO: 이름 바꿔라..
            monthlyChart3: null,  // peon별 막대 그래프 (실행 건수)
            monthlyChart4: null,  // scatter charts,
            monthlyChart5: null,  // 프로세스별 통계 (실행 건수)
            monthlyChart6: null,  // peon별 막대 그래프 (실행 시간)
            monthlyChart7: null,  // 프로세스별 통계 (실행 시간)

            selectedDate: new Date(),
            datepicker: {
                // date: new Date(2019, 2, 14),
                format: 'yyyy-MM-dd',
                highlighted: {
                    days: [6, 0]
                }
            },
            fromDate: new Date(),
            toDate: new Date(),

            selectedGroup: '',
            groupOptions: [
                { value: '', text: '전체' },
            ],

            botAllResultData: [], //20221212 추가
        }
    },
    components: {
        Loading,
        Datepicker
    },
    computed: {
        // yesterday() {
        //     var yesterday = new Date();
        //     yesterday.setDate(yesterday.getDate() - 1);

        //     return this.$moment(yesterday).format('YYYY-MM-DD');
        // },
        // lastMonth() {
        //     var lastMonth = new Date();
        //     lastMonth.setMonth(lastMonth.getMonth() - 1);
        //     lastMonth.setDate(1);

        //     return this.$moment(lastMonth).format('YYYY-MM-DD');
        // },
        thisMonth() {
            var thisMonth = new Date();
            thisMonth.setDate(1);

            return this.$moment(thisMonth).format('YYYY.MM');
        },
        // chartDeviceProcessOption() {
        //     if (!this.chartsLib)   return null;
        //     return this.chartsLib.charts.Bar.convertOptions({
        //                         // with: 640,
        //         // height: 800,
        //         width: 800,
        //         height: 640,
        //         chart: {
        //             title: "Running Processes Summary",
        //             // subtitle: "Sales, Expenses, and Profilt"
        //         },
        //         bars: 'horizontal',
        //         legend: { position: 'none' },
        //         series: {
        //             0: { axis: 'total' },
        //             1: { axis: 'running' }
        //         },
        //         axes: {
        //             x: {
        //                 total: { label: 'total' },
        //                 running: { side: 'top', label: 'running seconds' }
        //             }
        //         },
        //         // hAxis: {
        //         //     title: 'hello'
        //         // }
        //         // bar: { groupWidth: "90%" }
        //     })
        // },
        peonList() {
            return this.$store.state.peonList;
        },
        gridContainer() {
            return function (success, fail) {
                var x = 100, y = 0;

                if (success == 0 && fail == 0) {
                    x = 0;
                    y = 0;
                } else {
                    x = parseInt(success / (success + fail) * 10) * 10;
                    y = 100 - x;
                }

                return 'grid-container-' + x + '-' + y;
            }
        },
        getStat() {
            return function (peon, period, item = null) {
                if (this.$store.state.statistics[peon.deviceId] !== undefined) {
                    if (this.$store.state.statistics[peon.deviceId][period] !== undefined) {
                        if (item == null) {
                            return this.$store.state.statistics[peon.deviceId][period];
                        } else {
                            return this.$store.state.statistics[peon.deviceId][period][item];
                        }
                    }
                }

                return 0;
            }
        },
        getSummary() {
            return function (period, item) {
                if (this.$store.state.statisticsSummary !== undefined) {
                    if (this.$store.state.statisticsSummary[period] !== undefined) {
                        return this.$store.state.statisticsSummary[period][item];
                    }
                }

                return 0;
            }
        },
        ...mapState([
            'days'
        ])
    },
    // mounted() {
    //     this.$nextTick(() => {
    //         window.addEventListener('resize', this.windowResized);

    //         this.windowResized();
    //     });
    // },
    // beforeDestroy() {
    //     window.removeEventListener('resize', this.windowResized);
    // },
    filters: {
        currency: function (value) {
            var num = new Number(value);

            return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,");
        },
        readableTime: function (value) {
            if (value < 60) {
                return value + ' sec';
            } else if (value < 3600) {
                return parseInt(value / 60) + ' min ' + (value % 60) + ' sec';
            } else{
                return parseInt(value / 3600) + ' hr ' + parseInt((value % 3600) / 60) + ' min ' + (value % 60) + ' sec';
            }
        }
    },
    methods: {
        secondsToDate(seconds) {
            var seconds = parseInt(seconds, 10);

            var days = Math.floor(seconds / (3600 * 24));
            seconds -= days * 3600 * 24;
            var hrs = Math.floor(seconds / 3600);
            seconds -= hrs * 3600;
            var mnts = Math.floor(seconds / 60);
            seconds -= mnts * 60;

            var dateFormat = days + "일 " + hrs + "시 " + mnts + "분 " + seconds + "초";
            return dateFormat;
        },
        numberCommaFormat(number) {
            var numberString = number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
            return numberString;
        },
        exportExcel() {
            this.statisticsLoading = true;
            var params = {};
            var data = {
                'from': this.$moment(this.fromDate).format('YYYY-MM-DD'),
                'to': this.$moment(this.toDate).format('YYYY-MM-DD')
            };

            axios.post('peon/processStatistics', data, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                var processList = []
                var allProcessTotal = 0;
                var allProcessSuccess = 0;
                var allProcessFail = 0;
                var allRunningSeconds = 0;
                var allSuccessRunningSeconds = 0;
                var allFailRunningSeconds = 0;
                var allFeildFormat = {
                    '프로세스': '',
                    '총 수행건수': 0,
                    '성공 수행건수': 0,
                    '실패 수행건수': 0,
                    '총 수행시간': 0,
                    '성공 수행시간': 0,
                    '실패 수행시간': 0
                }

                response.data.body.list.forEach((item, index, array) => {
                    var feildFormat = {
                        '프로세스': '',
                        '총 수행건수': 0,
                        '성공 수행건수': 0,
                        '실패 수행건수': 0,
                        '총 수행시간': 0,
                        '성공 수행시간': 0,
                        '실패 수행시간': 0
                    }
                    feildFormat['프로세스'] = item.processName;
                    feildFormat['총 수행건수'] = this.numberCommaFormat(item.total);
                    allProcessTotal += parseInt(item.total);
                    feildFormat['성공 수행건수'] = this.numberCommaFormat(item.success);
                    allProcessSuccess += parseInt(item.success);
                    feildFormat['실패 수행건수'] = this.numberCommaFormat(item.fail);
                    allProcessFail += parseInt(item.fail);

                    feildFormat['총 수행시간'] = this.secondsToDate(item.runningSeconds);
                    allRunningSeconds += parseInt(item.runningSeconds);
                    feildFormat['성공 수행시간'] = this.secondsToDate(item.successRunningSeconds);
                    allSuccessRunningSeconds += parseInt(item.successRunningSeconds);
                    feildFormat['실패 수행시간'] = this.secondsToDate(item.failRunningSeconds);
                    allFailRunningSeconds += parseInt(item.failRunningSeconds);
                    processList.push(feildFormat);

                });

                allFeildFormat['프로세스'] = "TOTAL";
                allFeildFormat['총 수행건수'] = this.numberCommaFormat(allProcessTotal);
                allFeildFormat['성공 수행건수'] = this.numberCommaFormat(allProcessSuccess);
                allFeildFormat['실패 수행건수'] = this.numberCommaFormat(allProcessFail);
                allFeildFormat['총 수행시간'] = this.secondsToDate(allRunningSeconds.toString());
                allFeildFormat['성공 수행시간'] = this.secondsToDate(allSuccessRunningSeconds.toString());
                allFeildFormat['실패 수행시간'] = this.secondsToDate(allFailRunningSeconds.toString());
                processList.push(allFeildFormat);


                var botList = []
                var allBotTotal = 0;
                var allBotSuccess = 0;
                var allBotFail = 0;
                var allBotRunningSeconds = 0;
                var allBotSuccessRunningSeconds = 0;
                var allBotFailRunningSeconds = 0;
                var allBotFeildFormat = {
                    'BotName': '',
                    '총 수행건수': 0,
                    '성공 수행건수': 0,
                    '실패 수행건수': 0,
                    '총 수행시간': 0,
                    '성공 수행시간': 0,
                    '실패 수행시간': 0
                }
                //table3.push([ item.alias, item.success, item.fail ]);
                var botAllResultData = this.botAllResultData;

                for (var idx in botAllResultData) {
                    var feildFormat = {
                        'BotName': '',
                        '총 수행건수': 0,
                        '성공 수행건수': 0,
                        '실패 수행건수': 0,
                        '총 수행시간': 0,
                        '성공 수행시간': 0,
                        '실패 수행시간': 0
                    }
                    feildFormat['BotName'] = botAllResultData[idx][0];
                    feildFormat['총 수행건수'] = this.numberCommaFormat(botAllResultData[idx][1]);
                    allBotTotal += parseInt(botAllResultData[idx][1]);

                    feildFormat['성공 수행건수'] = this.numberCommaFormat(botAllResultData[idx][2]);
                    allBotSuccess += parseInt(botAllResultData[idx][2]);

                    feildFormat['실패 수행건수'] = this.numberCommaFormat(botAllResultData[idx][3]);
                    allBotFail += parseInt(botAllResultData[idx][3]);

                    feildFormat['총 수행시간'] = this.secondsToDate(botAllResultData[idx][4]);
                    allBotRunningSeconds += parseInt(botAllResultData[idx][4]);
                    feildFormat['성공 수행시간'] = this.secondsToDate(botAllResultData[idx][5]);
                    allBotSuccessRunningSeconds += parseInt(botAllResultData[idx][5]);
                    feildFormat['실패 수행시간'] = this.secondsToDate(botAllResultData[idx][6]);
                    allBotFailRunningSeconds += parseInt(botAllResultData[idx][6]);
                    botList.push(feildFormat);
                }

                allBotFeildFormat['BotName'] = "TOTAL";
                allBotFeildFormat['총 수행건수'] = this.numberCommaFormat(allBotTotal);
                allBotFeildFormat['성공 수행건수'] = this.numberCommaFormat(allBotSuccess);
                allBotFeildFormat['실패 수행건수'] = this.numberCommaFormat(allBotFail);
                allBotFeildFormat['총 수행시간'] = this.secondsToDate(allBotRunningSeconds);
                allBotFeildFormat['성공 수행시간'] = this.secondsToDate(allBotSuccessRunningSeconds);
                allBotFeildFormat['실패 수행시간'] = this.secondsToDate(allBotFailRunningSeconds);
                botList.push(allBotFeildFormat);

                var excelFileName = "notificationList_" + data.from + "_" + data.to + ".xlsx";
                var workBook = XLSX.utils.book_new(); // 새로운 workbook 생성                 
                var stdData = XLSX.utils.json_to_sheet(processList); // json 객체를 sheet로 변환하여 워크시트 생성
                var botData = XLSX.utils.json_to_sheet(botList); // json 객체를 sheet로 변환하여 워크시트 생성

                // 칼럼 너비 간격 조정
                var wscols = [
                    { wch: 40 },
                    { wch: 15 },
                    { wch: 15 },
                    { wch: 15 },
                    { wch: 20 },
                    { wch: 20 },
                    { wch: 20 }
                ];
                stdData['!cols'] = wscols;
                botData['!cols'] = wscols;
                //XLSX.utils.book_append_sheet(workBook, stdData, data.from + "_" + data.to + "_ProcessList"); // stdData 워크시트로 시트 생성, 해당 시트 이름 명명
                XLSX.utils.book_append_sheet(workBook, stdData, "ProcessList"); // stdData 워크시트로 시트 생성, 해당 시트 이름 명명
                XLSX.utils.book_append_sheet(workBook, botData, "BotList"); // stdData 워크시트로 시트 생성, 해당 시트 이름 명명   

                XLSX.writeFile(workBook, excelFileName); // 엑셀 파일 이름 설정하여 파일 생성;

            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.statisticsLoading = false;
            });
        },
        dailyTableExport() {
            var dailyTable = []
            var today = new Date();
            var dailyList = this.dailyList;
            var processName = '';
            for (var idx in dailyList) {
                var feildFormat = {
                    'No': '',
                    'Bot Name': '',
                    'Process Name': '',
                    '시작 시간': '',
                    '완료 시간': '',
                    '결과 Code': '',
                }

                feildFormat['No'] = Number(idx) + 1;
                feildFormat['Bot Name'] = dailyList[idx]['alias'];

                processName = this.showProcessName(dailyList[idx]['processName'], dailyList[idx]['version'], dailyList[idx]['file'])
                feildFormat['Process Name'] = processName;

                feildFormat['시작 시간'] = this.$moment(dailyList[idx]['startedTime']).format('YYYY-MM-DD HH:mm:ss');

                feildFormat['완료 시간'] = this.$moment(dailyList[idx]['finishedTime']).format('YYYY-MM-DD HH:mm:ss');

                feildFormat['결과 Code'] = dailyList[idx]['resultCode'];
                dailyTable.push(feildFormat);
            }

            var currentToday = this.$moment(today.toLocaleDateString()).format('YYYYMMDD');
            var excelFileName = "DailyTable_" + currentToday + ".xlsx";
            var workBook = XLSX.utils.book_new(); // 새로운 workbook 생성                 
            var tableData = XLSX.utils.json_to_sheet(dailyTable); // json 객체를 sheet로 변환하여 워크시트 생성

            // 칼럼 너비 간격 조정
            var wscols = [
                { wch: 5 },
                { wch: 15 },
                { wch: 40 },
                { wch: 20 },
                { wch: 20 },
                { wch: 10 },
                { wch: 10 }
            ];
            tableData['!cols'] = wscols;
            XLSX.utils.book_append_sheet(workBook, tableData, "dailyList"); // stdData 워크시트로 시트 생성, 해당 시트 이름 명명   

            XLSX.writeFile(workBook, excelFileName); // 엑셀 파일 이름 설정하여 파일 생성;
        },
        triggerProcessEvent(deviceId, uuid) {
            console.log('callMother');

            this.$emit('triggerProcessEvent', deviceId, uuid);
        },
        windowResized() {
            this.statisticsLoading = true;
            window.setTimeout(function () {
                if (this.monthlyChart3 != null) {
                    // this.options3 = {
                    //     'width': document.getElementById("chartBorder").clientWidth - 50,
                    //     'height': this.data3.getNumberOfRows() * 12,
                    //     'chartArea': { left: 35, top: 20, width: "85%", height: "85%" },
                    //     'bar': { groupWidth: '65%' },
                    //     'isStacked': true
                    // }

                    this.monthlyChart3.draw(this.data3, this.options3);
                }

                if (this.monthlyChart6 != null) {
                    this.monthlyChart6.draw(this.data6, this.options6);
                }

                if (this.monthlyChart4 != null) {
                    // this.options4 = {
                    //     'width': document.getElementById("chartBorder").clientWidth - 50,
                    //     'chartArea': { left: 35, top: 20, width: "85%", height: "85%" },
                    // }

                    this.monthlyChart4.draw(this.data4, this.options4);
                }

                if (this.monthlyChart5 != null) {
                    this.monthlyChart5.draw(this.data5, this.options5);
                }

                if (this.monthlyChart7 != null) {
                    this.monthlyChart7.draw(this.data7, this.options7);
                }

                if (this.dailyChart != null) {
                    this.dailyChart.draw(this.data0, this.options0);
                }

                this.statisticsLoading = false;
            }.bind(this), 100);

            console.log("called windowResized");
            // if (this.monthlyChart3 != null) {
            //     // this.options3 = {
            //     //     'width': document.getElementById("chartBorder").clientWidth - 50,
            //     //     'height': this.data3.getNumberOfRows() * 12,
            //     //     'chartArea': { left: 35, top: 20, width: "85%", height: "85%" },
            //     //     'bar': { groupWidth: '65%' },
            //     //     'isStacked': true
            //     // }

            //     this.monthlyChart3.draw(this.data3, this.options3);
            // }

            // if (this.monthlyChart4 != null) {
            //     // this.options4 = {
            //     //     'width': document.getElementById("chartBorder").clientWidth - 50,
            //     //     'chartArea': { left: 35, top: 20, width: "85%", height: "85%" },
            //     // }

            //     this.monthlyChart4.draw(this.data4, this.options4);
            // }

            // if (this.dailyChart != null) {
            //     this.dailyChart.draw(this.data0, this.options0);
            // }

        },
        onChartReady(chart, google) {
            this.chartsLib = google;
        },
        showMessage(status, message) {
            this.msgStatus = status;
            this.msgContent = message;

            this.$bvModal.show('messageModal');
        },
        openDatepicker(datepicker) {
            if (datepicker == 'datepicker1') {
                this.$refs.datepicker1.showCalendar();
            } else if (datepicker == 'datepicker2') {
                this.$refs.datepicker2.showCalendar();
            } else if (datepicker == 'fromDatePicker') {
                this.$refs.fromDatePicker.showCalendar();
            } else if (datepicker == 'toDatePicker') {
                this.$refs.toDatePicker.showCalendar();
            }
        },
        retrieveScriptRunningHistoryList() {
            this.statisticsLoading = true;

            var params = {};

            params.date = this.$moment(this.selectedDate).format('YYYY-MM-DD');
            if (this.selectedGroup != '') {
                params.group = this.selectedGroup;
            }

            axios.post('peon/retrieveScriptRunningHistoryList', params, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                this.totalDailyRunningSeconds = response.data.body.totalRunningSeconds;
                this.dailyList = response.data.body.list;

                var dailyChartTable = new window.google.visualization.DataTable();

                dailyChartTable.addColumn({ type: 'string', id: 'Peon' });
                dailyChartTable.addColumn({ type: 'string', id: 'Process' });
                dailyChartTable.addColumn({ type: 'date', id: 'Start' });
                dailyChartTable.addColumn({ type: 'date', id: 'End' });

                var alias = {};
                var rows = [];
                response.data.body.list.forEach((item, index, array) => {
                    alias[item.alias] = true;  // 개수를 세기 위해서이니 값은 상관 없음

                    rows.push([item.alias, this.showProcessName(item.processName, item.version, item.file), new Date(item.startedTime), new Date(item.finishedTime)]);
                });
                // rows.push([ 'Felix', 'last', new Date(2020, 2, 17, 23, 0, 0, 0), new Date(2020, 2, 17, 23, 59, 59, 999)]);
                rows.sort((a, b) => {
                    return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0;
                });

                dailyChartTable.addRows(rows);

                // 박유란 상무님 요청: 기존 Duration은 라이브러리 자체에서 지원하므로 수정하려면 tooltip을 이용해야함
                dailyChartTable.insertColumn(2, {type: 'string', role: 'tooltip', p: {html: true}});

                var dateFormat = new google.visualization.DateFormat({
                    pattern: 'yy/M/d h:mm a'
                });

                for (var i = 0; i < dailyChartTable.getNumberOfRows(); i++) {
                    var duration = (dailyChartTable.getValue(i, 4).getTime() - dailyChartTable.getValue(i, 3).getTime()) / 1000;
                    var hours = parseInt( duration / 3600 ) % 24;
                    var minutes = parseInt( duration / 60 ) % 60;
                    var seconds = duration % 60;

                    var tooltip = '<div class="ggl-tooltip" style="border: 1px solid #E0E0E0; padding: 6px; font-weight: bold; white-space: nowrap;">'
                        +'<span>' + dailyChartTable.getValue(i, 1) + '</span></div>'
                        +'<div class="ggl-tooltip" style="padding: 6px; font-weight: bold; white-space: nowrap;">'
                        +'<span>' + dailyChartTable.getValue(i, 0) + '</span>: ' + dateFormat.formatValue(dailyChartTable.getValue(i, 3)) + ' - ' + dateFormat.formatValue(dailyChartTable.getValue(i, 4))
                        + '</div>' +
                        '<div class="ggl-tooltip" style="padding: 6px; font-weight: bold;">'
                        + '<span>Duration: </span>' + hours + 'h ' + minutes + 'm ' + seconds + 's ';

                        dailyChartTable.setValue(i, 2, tooltip);
                }

                var dailyChartHeight = Object.keys(alias).length * 41 + 52;  // dataTable.getNumberOfRows() * 41 + 30;  // 다른 charts는 될 지 몰라도 Timeline은 rows가 그 의미가 아님

                var dailyChartWidth = document.getElementById('chartBorder').clientWidth - 42;

                var options = {
                    'height': dailyChartHeight,
                    'width': dailyChartWidth,
                    'tooltip': {isHtml: true}
                };

                this.data0 = dailyChartTable;
                this.options0 = options;
                this.dailyChart.draw(dailyChartTable, options);
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.statisticsLoading = false;
            });
        },
        async reloadStatistics() {
            console.log("reloadStatistics");

            await this.retrieveStatistics2();
            this.retrieveScriptRunningHistoryList();
        },
        retrieveStatistics2(date) {
            if (date != undefined) {

                var today = new Date();

                if (date == 'today') {
                    this.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                    this.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
                } else if (date == 'yesterday') {
                    this.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
                    this.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1);
                } else if (date == 'thisWeek') {
                    this.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay());
                    this.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (6 - today.getDay()));
                } else if (date == 'lastWeek') {
                    this.fromDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay() - 7);
                    this.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + (6 - today.getDay()) - 7);
                } else if (date == 'thisMonth') {
                    this.fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
                    this.toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                } else if (date == 'lastMonth') {
                    this.fromDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                    this.toDate = new Date(today.getFullYear(), today.getMonth(), 0);
                }
            }

            this.statisticsLoading = true;

            var params = {};
            var data = {
                'type': 'peon',
                'from': this.$moment(this.fromDate).format('YYYY-MM-DD'),
                'to': this.$moment(this.toDate).format('YYYY-MM-DD')
            };

            if (this.selectedGroup !== '') {
                data.group = this.selectedGroup;
            }

            axios.post('peon/retrieveStatistics2', data, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                this.totalRunningSeconds = 0;

                var success = 0, fail = 0;
                var successRunningSeconds = 0, failRunningSeconds = 0;
                var table3 = [['Peon', 'Success', 'Fail']];
                var table4 = [['Count', '실행 시간']];
                var table6 = [['Peon', 'Success', 'Fail']];
                var runningSeconds = null
                var botAllResultData = []
                response.data.body.list.forEach((item, index, array) => {

                    success += item.success;
                    fail += item.fail;
                    runningSeconds = item.runningSeconds
                    //console.log("running Second : "+runningSeconds)

                    //runingSecond가 null이면 0을 대입
                    if (runningSeconds == null) {
                        runningSeconds = 0;
                    }

                    this.totalRunningSeconds += runningSeconds;

                    successRunningSeconds += item.successRunningSeconds;

                    failRunningSeconds += item.failRunningSeconds;

                    table3.push([item.alias, item.success, item.fail]);

                    //bot total 변수 대입(20221212)
                    botAllResultData.push([item.alias, item.total, item.success, item.fail, runningSeconds, item.successRunningSeconds, item.failRunningSeconds]);

                    table6.push([item.alias, item.successRunningSeconds, item.failRunningSeconds]);

                    table4.push([item.total, runningSeconds]);
                });

                var data = google.visualization.arrayToDataTable([
                    ['Peon', 'Process'],
                    ['Success', success],
                    ['Fail', fail],
                ]);

                var options = {
                    pieSliceText: 'value',
                    title: 'Success / Fail 건수',
                    pieHole: 0.38
                };

                this.monthlyChart.draw(data, options);

                var data2 = google.visualization.arrayToDataTable([
                    ['Peon', 'Process'],
                    ['Success', successRunningSeconds],
                    ['Fail', failRunningSeconds]
                ]);

                var options2 = {
                    pieSliceText: 'value',
                    title: 'Success / Fail 실행 시간',
                    pieHole: 0.38
                };

                this.monthlyChart2.draw(data2, options2);

                table3.sort(function(a, b) {
                    return (b[1]+b[2]) - (a[1]+a[2]); // 1번째 인덱스(성공 횟수) 기준으로 정렬
                });

                table3 = table3.slice(0,11);

                var data3 = google.visualization.arrayToDataTable(table3);

                var options3 = {
                    title: 'Bot별 성공/실패 횟수',
                    height: 400,
                    isStacked: true,
                    vAxis: {
                        maxTextLines: 1, 
                    }
                };

                this.data3 = data3;
                this.options3 = options3;

                //bot통계 데이터 대입
                this.botAllResultData = botAllResultData;

                this.monthlyChart3.draw(data3, options3);

                table6.sort(function(a, b) {
                    return (b[1]+b[2]) - (a[1]+a[2]); // 1번째 인덱스(성공 횟수) 기준으로 정렬
                });

                table6 = table6.slice(0,11);

                var data6 = google.visualization.arrayToDataTable(table6);

                var options6 = {
                    title: 'Bot별 성공/실패 실행 시간',
                    height: 400,
                    isStacked: true,
                    vAxis: {
                        maxTextLines: 1, 
                    }
                };

                this.data6 = data6;
                this.options6 = options6;

                this.monthlyChart6.draw(data6, options6);

                var data4 = google.visualization.arrayToDataTable(table4);

                var options4 = {
                    title: '실행 횟수와 시간의 상관 관계',
                    trendlines: { 0: { color: 'green' } }
                };

                this.data4 = data4;
                this.options4 = options4;

                this.monthlyChart4.draw(data4, options4);
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.statisticsLoading = false;
            });

            var deviceData = {
                'type': 'process',
                'from': this.$moment(this.fromDate).format('YYYY-MM-DD'),
                'to': this.$moment(this.toDate).format('YYYY-MM-DD')
            };

            axios.post('peon/retrieveStatistics2', deviceData, {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(response => {
                var success = 0, fail = 0;
                var successRunningSeconds = 0, failRunningSeconds = 0;
                var table5 = [['Process', 'Success', 'Fail']];
                var table7 = [['Process', 'Success', 'Fail']];
                response.data.body.list.forEach((item, index, array) => {
                    success += item.success;
                    fail += item.fail;

                    successRunningSeconds += item.successRunningSeconds;
                    failRunningSeconds += item.failRunningSeconds;

                    table5.push([item.processName, item.success, item.fail]);
                    table7.push([item.processName, item.successRunningSeconds, item.failRunningSeconds]);
                });

                table5.sort(function(a, b) {
                    return (b[1]+b[2]) - (a[1]+a[2]); // 1번째 인덱스(성공 횟수) 기준으로 정렬
                });

                table5 = table5.slice(0,11);

                var data5 = google.visualization.arrayToDataTable(table5);

                var options5 = {
                    title: '프로세스별 성공/실패 횟수',
                    height: 400,
                    isStacked: true,
                    vAxis: {
                        maxTextLines: 1, 
                    }
                };

                this.data5 = data5;
                this.options5 = options5;

                this.monthlyChart5.draw(data5, options5);

                table7.sort(function(a, b) {
                    return (b[1]+b[2]) - (a[1]+a[2]); // 1번째 인덱스(성공 횟수) 기준으로 정렬
                });

                table7 = table7.slice(0,11);

                var data7 = google.visualization.arrayToDataTable(table7);

                var options7 = {
                    title: '프로세스별 성공/실패 시간',
                    height: 400,
                    isStacked: true,
                    vAxis: {
                        maxTextLines: 1, 
                    }
                };

                this.data7 = data7;
                this.options7 = options7;

                this.monthlyChart7.draw(data7, options7);
                
            }).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                this.statisticsLoading = false;
            });

        },
        showProcessName(processName, version, file) {
            if (processName == null || processName == '') {
                var strs = file.split('\\');

                if (strs == null || strs.length == 0) {
                    return file;
                } else {
                    return strs[strs.length - 1];
                }
            } else {
                return processName + '(' + version + ')';
            }
        },
        // peonClick() {
        //     axios.post('/peon/retrieveStatistics2', { 'type': 'peon', 'from': '2020-03-01', 'to': '2020-03-31' }, {
        //         headers: {
        //             'Accept': 'application/json',
        //             'Authorization': accessToken()
        //         }
        //     }).then(function (response) {
        //         if (response.data.status != 0) {
        //             alert(response.data.message);

        //             return;
        //         }

        //         this.chartDeviceProcessData = [
        //             [ "Peon", "Running Processes", "Running Seconds" ]
        //         ];
        //         // this.chartDeviceRunningData = [
        //         //     [ "Peon", "Running Seconds" ]
        //         // ];

        //         response.data.body.list.forEach(function(item, index, array) {
        //             var alias = this.$store.getters.getPeonAlias(item.deviceId);

        //             var title = alias === "" ? item.deviceId : alias + " (" + item.deviceId + ")";

        //             this.chartDeviceProcessData.push([title, item.total, item.runningSeconds / 3600]);
        //             this.chartDeviceRunningData.push([title, item.runningSeconds]);
        //         }.bind(this));
        //     }.bind(this))
        //     .catch(function(response) {
        //         alert('Failed to retrieveStatistics');
        //     }.bind(this))
        // },
        // processClick() {
        //     axios.post('/peon/retrieveStatistics2', { 'type': 'process', 'from': '2020-03-01', 'to': '2020-03-31' }, {
        //         headers: {
        //             'Accept': 'application/json',
        //             'Authorization': accessToken()
        //         }
        //     }).then(function (response) {
        //         if (response.data.status != 0) {
        //             alert(response.data.message);

        //             return;
        //         }

        //         this.chartScriptFileData = [
        //             // [ "Peon", "Running Processes", "Running Seconds" ]
        //             [ "Peon", "Running Processes" ]
        //         ];

        //         response.data.body.list.forEach(function(item, index, array) {
        //             // this.chartScriptFileData.push([item.scriptFile, item.total, item.runningSeconds / 3600]);
        //             this.chartScriptFileData.push([item.processName, item.total]);
        //         }.bind(this));
        //     }.bind(this))
        //     .catch(function(response) {
        //         alert('Failed to retrieveStatistics');
        //     }.bind(this))
        // },
        getPercentage: function (num, total) {
            total = Number(total);
            num = Number(num);

            if (isNaN(total) || isNaN(num)) return 0;
            if (total <= 0 || num < 0) return 0; // 값이 음수이거나 
            if (total < num) return 100; // 전체 보다 숫자가 많을 경우 

            return parseInt(((num / total) * 100));
        },
        drawDailyProcess() {
            var container = document.getElementById('dailyTimeline');
            this.dailyChart = new window.google.visualization.Timeline(container);

            this.retrieveScriptRunningHistoryList();
        },
        drawMonthlyPeon() {
            var container = document.getElementById('monthlyPeon');
            this.monthlyChart = new window.google.visualization.PieChart(container);

            var container2 = document.getElementById('monthlyPeon2');
            this.monthlyChart2 = new window.google.visualization.PieChart(container2);

            var container3 = document.getElementById('monthlyPeon3');
            this.monthlyChart3 = new window.google.visualization.BarChart(container3);

            var container6 = document.getElementById('monthlyPeon6');
            this.monthlyChart6 = new window.google.visualization.BarChart(container6);

            var container4 = document.getElementById('monthlyPeon4');
            this.monthlyChart4 = new window.google.visualization.ScatterChart(container4);

            var container5 = document.getElementById('monthlyPeon5');
            this.monthlyChart5 = new window.google.visualization.BarChart(container5);

            var container7 = document.getElementById('monthlyPeon7');
            this.monthlyChart7 = new window.google.visualization.BarChart(container7);

            this.retrieveStatistics2();
        },
        retrieveGroupList() {
            axios.get('device/retrieveGroupListByUser', {
                headers: {
                    'Accept': 'application/json',
                    'Authorization': accessToken()
                }
            }).then(function (response) {  // 이 response는 WorkMan이 status를 0으로 보낸 경우만 해당됨 (나머지 status가 0이 아닌 논리 오류는 main.js에서 이미 error로 보내도록 되어 있음)
                // this.submitted = false;

                // this.groupList = response.data.body.list;
                // this.groupOptions = [
                //     { value: '', text: '전체' },
                // ];

                response.data.body.list.forEach((group) => {
                    this.groupOptions.push({
                        value: group.groupId, text: group.groupId + " (" + group.description + ")"
                    });
                });

                // this.total = response.data.body.total;
            }.bind(this)).catch(error => {
                if (error.status != 401) {
                    this.showMessage(error.status == 200 ? error.code : error.status, error.message);
                }
            }).finally(() => {
                // this.retrieveGroupListLoading = false;
            });
        },

    },
    created() {
        this.retrieveGroupList();

        var today = new Date();

        this.fromDate = new Date(today.getFullYear(), today.getMonth(), 1);
        this.toDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);

        window.google.charts.load('current', { 'packages': ['corechart', 'timeline'] });

        window.google.charts.setOnLoadCallback(this.drawDailyProcess);
        window.google.charts.setOnLoadCallback(this.drawMonthlyPeon);
    }
}
</script>

<style>
.vdp-datepicker>div>input {
    display: none;
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
$success: #072B31;
$fail : #FF8200;
$none : #CBCBCB;

/* For statistics page START */

.item_success {
    background-color: $success;
    border-radius: 5px 0px 0px 5px;
    overflow: hidden;
    height: 25px;
}

.item_fail {
    background-color: $fail;
    border-radius: 0px 5px 5px 0px;
    overflow: hidden;
    height: 25px;
}

.item_slim_success {
    background-color: $success;
    border-radius: 5px 0px 0px 5px;
    overflow: hidden;
    height: 5px;
}

.item_slim_fail {
    background-color: $fail;
    border-radius: 0px 5px 5px 0px;
    overflow: hidden;
    height: 5px;
}

.grid-container-0-0 {
    display: grid;
    grid-template-columns: 100% 0%;
    grid-gap: 2px;
}

.grid-container-0-0>.item_success {
    background-color: $none;
    border-radius: 5px;
}

.grid-container-0-0>.item_slim_success {
    background-color: $none;
    border-radius: 5px;
}

.grid-container-100-0>.item_success,
.grid-container-100-0>.item_slim_success {
    background-color: $success;
    border-radius: 5px;
}

.grid-container-0-100 .item_fail,
.grid-container-0-100 .item_slim_fail {
    background-color: $fail;
    border-radius: 5px;
}

/*
[class*="grid-container"] > div {
 text-align: center;
 color : white;
 
}
*/

@mixin grid-value($num1, $num2) {
    display: grid;
    grid-template-columns: $num1*1% $num2*1%;
    //grid-template-rows: 25px;
    grid-gap: 2px;
}

$totalNum: 100;
$j: 0;
$perNum1: 0%;
$perNum2: 0%;


@for $i from 0 through $totalNum {
    $j: $totalNum - $i;

    .grid-container-#{$i}-#{$j} {
        @include grid-value($i, $j);
    }
}


@keyframes fade {
    from {
        background-color: #97999B;
    }
}

.bar-animated {
    animation: fade 2s 1 ease-in-out;
}</style>
